export interface UseCase {
  id: string;
  title: string;
  thumbnail: string;
  suggestions: string[];
  defaultText: string;
}

export const useCases: UseCase[] = [
  {
    id: 'change-object',
    title: 'Change object',
    thumbnail: 'video-editor/change-object.png',
    suggestions: [
      'Change color',
      'Replace object',
      'Change subject',
      'Remove object',
    ],
    defaultText: 'Modify, replace or delete an object in the video...',
  },
  {
    id: 'change-background',
    title: 'Change background',
    thumbnail: 'video-editor/change-background.png',
    suggestions: [
      'Change weather',
      'Change lighting',
      'Change backdrop',
      'Use background from reference image',
    ],
    defaultText: 'Change the styling or details of the video background...',
  },
  {
    id: 'change-colors',
    title: 'Change colors',
    thumbnail: 'video-editor/change-colors.png',
    suggestions: [
      'Make color palette cooler/warmer',
      'Match color palette to reference image',
    ],
    defaultText: 'Modify the color palette of the video...',
  },
  {
    id: 'change-video-style',
    title: 'Change video style',
    thumbnail: 'video-editor/change-video-style.png',
    suggestions: ['Make video animated', 'Match style of image'],
    defaultText: 'Modify the styling and aesthetics of a video...',
  },
  {
    id: 'remove-background',
    title: 'Remove background',
    thumbnail: 'video-editor/remove-background.png',
    suggestions: ['Remove background'],
    defaultText: 'Remove the background to isolate the subject of the video...',
  },
  {
    id: 'custom-edit',
    title: 'Custom edit',
    thumbnail: 'video-editor/custom-edit.png',
    suggestions: [
      'Add elements',
      'Change motion',
      'Add effects',
      'Change framing',
      'Change mood',
    ],
    defaultText: 'Customize the video in your own way...',
  },
];

export const CREDIT_COST = 750; // $0.75

export const MIN_SELECTION_DURATION = 2;
export const MAX_SELECTION_DURATION = 5;
export const TIME_PRECISION = 2;

export const TIMELINE_MAX_THUMBNAILS = 16;

export const FILMSTRIP_STRIP_HEIGHT = 40;
export const VERTICAL_OVERRIDE_THUMBNAIL_COUNT = 16;
// Vertical thumbnails are 1.6x the width
export const VERTICAL_THUMBNAIL_HEIGHT_RATIO = 1.6;

export const PROMPTING_GUIDE_URL =
  '/resources/blog/creative-ways-to-use-ai-video-editing-tool';
